"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var useEffectOnce_1 = tslib_1.__importDefault(require("./useEffectOnce"));

var useMount = function useMount(fn) {
  useEffectOnce_1["default"](function () {
    fn();
  });
};

exports["default"] = useMount;